import { mapActions, mapMutations, mapStates, mapGetters } from './../baseModule'
import { dashboardSurveysCounter } from 'src/services/DashboardCounter.js'
import Couchdb from 'src/services/Couchdb'
import store from 'src/vuex/store'

const collection = 'surveys'
const connection = 'surveys'

const model = {
  ticketId: null,
  customerId: null,
  customer: null,
  userId: null,
  user: null,
  survey: null
}

const validations = {
  ticketId: { required: true },
  customerId: { required: true },
  customer: { required: true },
  userId: { required: true },
  user: { required: true },
  survey: { required: false }
}

const getters = Object.assign({...mapGetters()}, {
  surveys: state => state.all,
  survey: state => state.one,
  loading: state => state.loading,
  validations: state => state.validations,
  surveyValid: state => state.all.filter(survey => {
    return survey.status === 'FINISHED' &&
      (!survey.alert || survey.alert === 'false') &&
      survey.hasOwnProperty('data') &&
      (!survey.data.absent || survey.data.absent === 'false') &&
      (survey.data.accepted && survey.data.accepted !== 'false')
  })
})

export default {
  namespaced: true,

  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0
  },

  mutations: {
    ...mapMutations(),

    setCount: (state, payload) => {
      state.count = payload
    }
  },

  actions: {
    ...mapActions(collection, model, connection),

    associateSurveys ({commit, dispatch}, surveys) {
      return new Promise((resolve) => {
        commit('changeLoading', true)
        let oldSurveys = store.state.surveys.all
        let logSurveys = []
        let tickets = []

        surveys = surveys.map(newSurvey => {
          let old = oldSurveys.find(surveyOld => {
            return surveyOld.ticketId === newSurvey.ticketId && surveyOld.surveyType === newSurvey.surveyType
          })

          if (old) {
            logSurveys.push({
              old,
              new: Object.assign({}, newSurvey)
            })
            newSurvey._id = old._id
            newSurvey._rev = old._rev
            newSurvey.updatedAt = new Date()
          } else {
            newSurvey.createdAt = new Date()
          }

          let ticket = Object.assign({}, newSurvey.ticket)
          ticket.surveyAssociated = true
          delete ticket.event
          delete ticket.customer
          delete ticket.stock
          tickets.push(ticket)

          delete newSurvey.ticket
          return newSurvey
        })
        console.log('survey to save', surveys)
        return Couchdb.connection('surveys').collection('surveys')
          ._postBulkDocs(surveys)
          .then(res => {
            dispatch('tickets/setSurveyAssociated', { tickets }, { root: true })
            dispatch('fetchViewAll', {
              ddoc: 'surveys-by-event',
              view: 'surveys-by-event',
              key: surveys[0].event._id
            })

            if (logSurveys.length > 0) {
              dispatch('insertLogs', logSurveys)
            }
            resolve(true)
          })
          .catch((err) => {
            console.log(err)
            resolve(false)
          })
          .finally(() => {
            commit('changeLoading', false)
          })
      })
    },

    cleanSurvey ({commit, dispatch}, survey) {
      return new Promise((resolve) => {
        commit('changeLoading', true)
        let doc = {
          _id: survey._id,
          ticketId: survey.ticketId,
          customer: survey.customer,
          data: {},
          status: 'TODO',
          user: survey.user,
          event: survey.event,
          userId: survey.userId,
          surveyType: survey.surveyType,
          createdAt: survey.createdAt,
          collection: survey.collection
        }

        Couchdb.collection('surveys')
          ._update(doc._id, doc, 'surveys')
          .then(res => {
            dispatch('fetchViewAll', {
              ddoc: 'surveys-by-event',
              view: 'surveys-by-event',
              key: survey.event._id
            })
            resolve(true)
          })
          .catch(err => {
            console.log(err)
            resolve(false)
          })
          .finally(() => commit('changeLoading', false))
      })
    },

    counterSurveys ({commit}) {
      commit('changeLoading', true)
      Couchdb.connection('surveys').collection('surveys')
        .viewReduce('counters-surveys-by-status', 'counters-surveys-by-status')
        .then(res => {
          let finished = res.rows.find(item => item.key === 'finished')
          let todo = res.rows.find(item => item.key === 'todo')
          commit('setCount', {
            finished: finished ? finished.value : 0,
            todo: todo ? todo.value : 0
          })
        })
        .finally(() => commit('changeLoading', false))
    },

    dashboardSurveysByFilter ({ commit }, { eventsId, dateRange }) {
      commit('changeLoading', true)
      return dashboardSurveysCounter(eventsId, dateRange)
        .then(result => {
          console.log(result)
          commit('SET_DASHBOARD_COUNTER', result)
          commit('changeLoading', false)
          return result
        })
        .catch((err) => {
          commit('changeLoading', false)
          console.log(err)
          return err
        })
    }
  },
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/surveys.js